/* eslint-disable react/jsx-no-useless-fragment */
import React, { useMemo } from "react";

import { Tab, TabbedRoute } from "@/components/common/navigation/Tabbedroute";

export const CompanySettingsRoute: React.FC = () => {
  const tabs = useMemo<Array<Tab>>(
    () => [
      { to: "practise-profile", text: "Practice Profile" },
      { to: "team", text: "Team" },
      { to: "billing", text: "Billing" },
      { to: "connections", text: "Connections" }
    ],
    []
  );

  return (
    <React.Fragment>
      <TabbedRoute tabs={tabs} />
    </React.Fragment>
  );
};
